import React from 'react';
import styled from 'styled-components';
import {
  Title,
  Wrapper,
  Card
} from '../../../ChangeStudiesOption/info/components';
import WhiteContainer from '@/presentation/modules/procedures/components/ContainerProcedure/WhiteContainer';
import Link from '@/presentation/reusables/Link';

const ProcedureInformationText = styled.div`
  ul {
    list-style: disc;
    /* margin-left: 0px; */
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;
  }
`;

interface ProcedureInfoComponentProps {
  inRegister?: boolean;
}

const ProcedureInfoComponent = ({
  inRegister
}: ProcedureInfoComponentProps) => (
  <>
    <WhiteContainer inRegister={inRegister}>
      <Wrapper>
        <Card>
          <ProcedureInformationText>
            <Title>Requisitos necesarios</Title>
            <ul
              style={{
                marginTop: 8
              }}
            >
              La nota de tu evaluación deberá estar publicada en{' '}
              <b>Mis cursos</b> y cumplir con los siguientes plazos para
              presentar tu solicitud:
              <ul
                style={{
                  marginLeft: 16
                }}
              >
                <li>
                  Si es un examen final, podrás solicitar este trámite dentro de
                  las 24 horas posteriores a la publicación de la nota.
                </li>
                <li>
                  Si es una evaluación continua, podrás solicitar este trámite
                  dentro de los 7 días calendarios posteriores a la publicación
                  de la nota.
                </li>
              </ul>
              <br />
              <p>Contar con el sustento de tu evaluación.</p>
              <p>
                Para evaluaciones virtuales,{' '}
                <Link
                  linkType="external"
                  url="https://drive.google.com/file/d/1nS90GBEwOKQCGXbTNNeCEm6qV8yv8mE3/view"
                  linkName="revisa los ejemplos de sustento."
                />
              </p>
            </ul>
          </ProcedureInformationText>
        </Card>
      </Wrapper>
    </WhiteContainer>
    <WhiteContainer
      style={{
        marginTop: 12
      }}
    >
      <Card>
        <ProcedureInformationText>
          <Title>Consideraciones</Title>
          <ul
            style={{
              marginTop: 8
            }}
          >
            Solo será atendida tu solicitud si presentas alguno de estos casos
            indicados en el articulo 57 del Reglamento de Estudios:
            <ul
              style={{
                marginLeft: 16
              }}
            >
              <li>Error en la suma de la nota.</li>
              <li>Pregunta no calificada.</li>
            </ul>
            <br />
          </ul>
        </ProcedureInformationText>
      </Card>
    </WhiteContainer>
    <div
      style={{
        marginTop: 12
      }}
    >
      <WhiteContainer>
        <Wrapper>
          <ProcedureInformationText>
            <Card>
              <Title>Pasos a seguir:</Title>
              <div>
                <ol
                  style={{
                    listStyleType: 'lower-aplha',
                    marginLeft: '16px',
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '20px',
                    color: '#161D1F'
                  }}
                >
                  <li>Completa la información solicitada.</li>
                  <ul>
                    <li>
                      Selecciona el curso, tipo de evaluación y el motivo.
                    </li>
                    <li>Adjunta el sustento.</li>
                  </ul>
                  <br />
                  <li>
                    Espera la atención de tu solicitud, te avisaremos por correo
                    y revisa la respuesta de UTP.
                  </li>
                </ol>
              </div>
            </Card>
          </ProcedureInformationText>
        </Wrapper>
      </WhiteContainer>
    </div>
  </>
);

export { ProcedureInfoComponent };
